export const SELLER_DETAILS_KPI = {
	SELLER: 'seller_details',
	PRODUCT: 'product_details'
}